import React from 'react'
import { Row, Col, Typography, theme, Button } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import '../style/DesktopSectionHeader.css'
import { hexToRGBA } from '../../../../lib/utils'

const { Title, Text } = Typography

const DesktopSectionHeader = ({ icon, title, subtitle, onBack }) => {
  const { token } = theme.useToken()

  return (
    <div className='desktop-section-header-card' style={{ background: hexToRGBA(token.colorPrimary, 0.05) }}>
      <Row align='middle' justify='space-between' gutter={[16, 8]}>
        <Col flex='auto'>
          <div className='desktop-section-header-content'>
            <div
              className='desktop-section-icon-container'
              style={{
                boxShadow: `0 0 20px 0 ${hexToRGBA(token.colorPrimary, 0.3)}`,
                background: hexToRGBA(token.colorPrimary, 0.1)
              }}
            >
              <FontAwesomeIcon icon={icon} style={{ color: token.colorPrimary }} />
            </div>

            <div className='desktop-section-text'>
              <Title level={2} className='desktop-section-header-title'>
                {title}
              </Title>
              {subtitle && <Text className='desktop-section-header-subtitle'>{subtitle}</Text>}
            </div>
          </div>
        </Col>

        {onBack && (
          <Col>
            <Button
              type='default'
              icon={<FontAwesomeIcon icon={faArrowLeft} />}
              onClick={onBack}
              className='desktop-back-button'
              size='large'
            >
              Back to Overview
            </Button>
          </Col>
        )}
      </Row>
    </div>
  )
}

export default DesktopSectionHeader
